import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import SubscribeContact from "../components/subscribeContact";
import TableOfContents from "../components/table-of-contents";
import TopNavabr from "../components/topNavabr";
import { solarAlternativeSubMenus } from "../data/solar-alternative-submenu";
import { useScrollTop } from "../hook/useScrollTop";
import solarBannerImg from "../images/afro-solar/solar-banner.webp";
import AgriSolar from "../sections/agri-solar";
import CommercialSolution from "../sections/commercial-solution";
import Financing from "../sections/financing";
import IndustrialSolution from "../sections/industrial-solution";
import InternationalProjects from "../sections/international-projects";
import LargeProjectsExample from "../sections/large-projects-example";
import MegaProjects from "../sections/mega-projects";
import OnGridProjectExamples from "../sections/on-grid-project-examples";
import OperationsAndMaintenance from "../sections/operations-and-maintainance";
import OurValues from "../sections/our-values";
import PowerSolution from "../sections/power-solution";
import RealStateSolution from "../sections/realstate-solution";
import RemoteMonitoring from "../sections/remote-monitoring";
import SolarMicroGridTwo from "../sections/sloar-microgrid-2";
import SmartCity from "../sections/smart-city";
import SolarMicroGrids from "../sections/solar-microgrids";
import SolarPump from "../sections/solar-pump";
import TheBetterEnergyChoice from "../sections/the-better-energy-choice";

const SolarAlternativeEnergy = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Solar Alternative Energy</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={solarBannerImg}>
        <div className="pt-7 pb-5 text-center">
          <div className="header-background-image-size">
            <h1 className="fs-56 mt-4 text-capitalize flex align-items-center gilroy-bold">
              AFRO<span className="text-orange-ryb">SOLAR</span>
            </h1>
            <p className="fs-28 gilroy-bold text-white">
              Turnkey Solar Power Technologies
            </p>
          </div>
        </div>
      </Header>
      <section className="d-none d-lg-block position-sticky top-0 w-100">
        <ul className="d-flex justify-content-around fs-14 text-center p-0 m-0 align-items-stretch">
          {solarAlternativeSubMenus.map((menu, index) => (
            <li
              key={index}
              className="list-style-none submenu-link border-gray w-100 d-flex align-items-center justify-content-center"
            >
              <a
                href={menu.link}
                className="text-decoration-none gilroy-bold d-block py-3"
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </section>
      <TableOfContents routes={solarAlternativeSubMenus} />
      <SmartCity />
      <section className="d-flex align-items-end solar-alt-accelerate mt-13">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-5 bg-american-yellow pt-7 pb-7 px-5">
            <h2 className="fs-56 lh-64 gilroy-bold mb-5 text-white">
              Accelerate clean energy access for millions globally
            </h2>
            <p className="fs-16 lh-30 text-align-justify">
              We are an EPC (Energy Procurement Construction) company that
              finances, designs, installs, and commissions PV (Photovoltaic)
              solar power plants. Our dream is the blanketing of Africa's golden
              deserts and Asian plateaus with solar panels and unlocking its
              massive energy potential to help our partners meet the United
              Nations ambitious goal of net-zero carbon emissions commitments.
              We thrive towards a greener world through capitalizing on
              resources and protecting the environment. Opting for a solar
              energy solution promotes and positions your company as an
              environmentally responsible and forward-thinking brand that
              invests intelligently and operates sustainably. AFRO Solar is part
              of the AFRP Group.
            </p>
          </div>
          <div className="col-12 col-md-12 col-lg-7">
            <div className="row h-100 text-center align-items-end">
              <div className="col-12 bg-bright-gray col-sm-4 col-md-4 py-5 border-right-yellow solar-alt-accelerate-height">
                <h3 className="fs-28 gilroy-bold">ZERO</h3>
                <p className="fs-16 px-8">
                  Permits, installation, operation or maintenance costs.
                </p>
              </div>

              <div className="col-12 bg-bright-gray col-sm-4 col-md-4 pb-5 py-md-5 border-right-yellow solar-alt-accelerate-height">
                <h3 className="">
                  Up to{" "}
                  <span className="fs-28 gilroy-bold text-orange-ryb">95%</span>
                </h3>
                <p className="fs-16 px-8">
                  Electricity consumed from clean solar and alternative energy
                </p>
              </div>

              <div className="col-12 bg-bright-gray col-sm-4 col-md-4 pb-5 py-md-5 solar-alt-accelerate-height">
                <h3 className="fs-28 gilroy-bold">$0</h3>
                <p className="fs-16 px-8">
                  Upfront investment in the solar station through our financial.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <TheBetterEnergyChoice />
      <OurValues />
      <MegaProjects />
      <IndustrialSolution />
      <CommercialSolution />
      <RealStateSolution />
      <SolarPump />
      <AgriSolar />
      <PowerSolution />
      <SolarMicroGrids />
      <SolarMicroGridTwo />
      <OperationsAndMaintenance />
      <Financing />
      <OnGridProjectExamples />
      <InternationalProjects />
      <LargeProjectsExample />
      <RemoteMonitoring />
      <SubscribeContact />
      <Footer />
    </>
  );
};

export default SolarAlternativeEnergy;
